import { AxiosError } from 'axios';
import instance from '../config/axios';

export async function previewTrainingTools(token: string, resourceId: string) {
  try {
    const response = await instance({
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/pdf',
      },
      method: 'GET',
      responseType: 'blob',
      url: `/api/v1/preview/training-tools/${resourceId}`,
    });

    return response.data;
  } catch (e) {
    return (e as AxiosError).response!.status;
  }
}
